/**
 * @flow
 * @relayHash 196fa18283bd67d5719b68da6dce3837
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompleteStaffAccountInput = {|
  staffToken: string,
  uidb64: string,
  password: string,
  clientMutationId?: ?string,
|};
export type CompleteStaffAccountMutationVariables = {|
  completeStaffAccountInput: CompleteStaffAccountInput
|};
export type CompleteStaffAccountMutationResponse = {|
  +completeStaffAccount: ?{|
    +user: ?{|
      +email: string
    |}
  |}
|};
export type CompleteStaffAccountMutation = {|
  variables: CompleteStaffAccountMutationVariables,
  response: CompleteStaffAccountMutationResponse,
|};
*/


/*
mutation CompleteStaffAccountMutation(
  $completeStaffAccountInput: CompleteStaffAccountInput!
) {
  completeStaffAccount(input: $completeStaffAccountInput) {
    user {
      email
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "completeStaffAccountInput",
    "type": "CompleteStaffAccountInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "completeStaffAccountInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CompleteStaffAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "completeStaffAccount",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteStaffAccountPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "UserNode",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CompleteStaffAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "completeStaffAccount",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteStaffAccountPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "UserNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "CompleteStaffAccountMutation",
    "id": null,
    "text": "mutation CompleteStaffAccountMutation(\n  $completeStaffAccountInput: CompleteStaffAccountInput!\n) {\n  completeStaffAccount(input: $completeStaffAccountInput) {\n    user {\n      email\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '364d7bfb2af4d067425456928453f1d5';
module.exports = node;
